<template>
	<div class="downline">
		<div class="breadcrumb">{{onlineText}}列表
			<el-button class="right_f" type="primary" @click="cancel">取消</el-button>
		</div>

		<div class="com-list">
			<!-- 替换列表 -->
			<el-table :data="list_change">
				<el-table-column prop="position" label="替换序号" align='center' width="120">
				</el-table-column>
				<el-table-column prop="prizeName" label="奖品名称" align='center'>
				</el-table-column>
				<el-table-column inline-template label="图片" align='center'>
					<div>
						<img :src="row.imgUrl" style="display:inline-block;width:150px;margin-top:5px;">
					</div>
				</el-table-column>
				<el-table-column prop="prizeCount" label="数量" align='center'>
				</el-table-column>
				<el-table-column label="替换时间" inline-template align='center'>
					<div v-if="row.replaceStartTime && row.replaceEndTime">
						<div>{{row.replaceStartTime}} - {{row.replaceEndTime}}</div>
					</div>
				</el-table-column>
				<el-table-column label="兑换时间" inline-template align='center'>
					<div>
						<div v-if="row.startTime && row.endTime">{{row.startTime}} - {{row.endTime}}</div>
					</div>
				</el-table-column>
				<el-table-column prop="applicableCampus" label="学校" align='center'>
				</el-table-column>
				<el-table-column inline-template label="最近操作记录" align='center' width="200">
					<div>
						<div>{{row.operator}}</div>
						<div>{{row.operateTime}}</div>
					</div>
				</el-table-column>
				<el-table-column inline-template label="操作">
					<span>
						<el-button class="option" type="text" @click="toDet(row.id)">详情</el-button>
						<el-button class="option" type="text" @click="unPublish(row)" v-if="this.online ==0">下线</el-button>
					</span>
				</el-table-column>
			</el-table>
		</div>

	</div>
</template>
<script>
	import { mapState, mapActions } from "vuex";

	export default {
		data() {
			return {
				list_change: [],
				online: this.$util.getUrlParam("online") * 1,
				needUpdate: false,
				onlineText:
					this.$util.getUrlParam("online") * 1 == 2 ? "已下线" : "待上线",
				operatorId: this.$store.state.user.userId
			};
		},
		mounted() {
			//默认请求列表
			this.getList();
		},
		methods: {
			getList() {
				let url = this.$util.domain + "/adminapi/v2/rounddisk/replace/list";

				//请求列表的ajax；
				this.$http({
					url,
					method: "GET",
					headers: {
						operatorId: this.operatorId + ""
					},
					params: {
						type: this.online
					}
				}).then(response => {
					//请求成功，重置列表数组；
					this.list_change = [];

					if (response.data.error === 10000) {
						let dataList = response.data.data;

						//对请求数据进行遍历格式化，并赋值给列表数组；
						dataList.forEach(item => {
							this.list_change.push({
								id: item.id,
								position: item.position,
								prizeName: item.prizeName,
								imgUrl: item.imgUrl,
								prizeCount: item.prizeCount == -1 ? "无限" : item.prizeCount,
								operator: item.operator,
								startTime: item.startTime
									? new Date(item.startTime).format("yyyy.MM.dd")
									: "",
								endTime: item.endTime
									? new Date(item.endTime).format("yyyy.MM.dd")
									: "",
								replaceStartTime: item.replaceStartTime
									? new Date(item.replaceStartTime).format("yyyy.MM.dd")
									: "",
								replaceEndTime: item.replaceEndTime
									? new Date(item.replaceEndTime).format("yyyy.MM.dd")
									: "",
								applicableCampus: item.applicableCampus == 0 ? "全部" : "部分",
								operateTime: item.operateTime
									? new Date(item.operateTime).format("yyyy.MM.dd hh:mm")
									: ""
							});
						});
					} else {
						this.$util.errorMsg(response.data.message);
					}
				});
			},
			toDet(id) {
				location.href = `/#/yunying/integration/inteChangeDet?id=${id}&isReplace=${
					this.online
					}`;
			},
			cancel() {
				location.href =
					"/#/yunying/integration/integration?isFirst=1&needUpdate=" +
					this.needUpdate;
			},
			//下线
			unPublish(row) {
				//弹出确认是否下线弹出框
				this.$confirm(`是否要下线${row.prizeName}`, "提示", {
					confirmButtonText: "是",
					cancelButtonText: "否",
					type: "warning"
				}).then(() => {
					//选择确定，发送ajax请求，下线奖品;
					let url = this.$util.domain + "/adminapi/v2/rounddisk/replace/offline";

					this.$http({
						url,
						method: "POST",
						headers: {
							operatorId: this.operatorId + ""
						},
						body: JSON.stringify({
							id: row.id * 1
						})
					})
						.then(response => {
							if (response.data.error === 10000) {
								this.$util.successMsg("下线成功");
								this.needUpdate = true;
								this.getList();
							} else {
								this.$util.errorMsg(response.data.message);
							}
						})
						.catch(response => {
							//选择否，关闭弹框；
						});
				});
			}
		}
	};
</script>

<style>
</style>


// WEBPACK FOOTER //
// downline.vue?00bef823